import * as PIXI from "pixi.js";
import "leaflet-pixi-overlay"; // Must be called before the 'leaflet' import
import L, { LatLngExpression, Point } from "leaflet";
import mapArrowUnit from "@images/mapArrowUnit.svg"
import mapStandArrowUnit from "@images/mapStandArrowUnit.svg"
import { getColorByStatusUnits, hex2number } from "@utils/getColorByStatusUnit";
import { HashElement, TrackPoint, UnitHashElement } from "@context/map/units/unitsStore";
import { ModeEnum } from "@components/modules/map/MapContainer";
import logger from "@utils/logger";
import { GeoZoneHashElement } from "@context/map/fields/fieldsStore";
import { AsObjectHashMap } from "@context/map/utilMutableStore";
import { MapRenderer } from "@api/pixijs/renderers/OperationRenderer";
import { groupByProp } from "@utils/utils";

// TODO! REMOVE! DEPRECATED!!!!!

enum SelectEnum {
  SELECT = "SELECT",
  CLEAR_SELECT = "CLEAR_SELECT",
  CLEAR_ALL = "CLEAR_ALL"
}

enum GlobalLayerEnum {
  PIXI = "PIXI",
  LEAFLET = "LEAFLET"
}

/**
 *
 * Service for rendering large count fields
 * draw on layers canvas
 *
 * map - leaflet maps  // const map = useMap()
 * funcSelect - func take field id(field)
 *
 * render - call when field are redraw
 *
 * field = {
    area: 9.474389525418921
    color: 13434828
    comment: "comm"
    department: "Миякинский филиал"
    departmentId: 12115
    fieldOps: []
    geometry: {
      type: 'Polygon',
      coordinates: [
        [55.07581458785696, 53.1588363741635]
        [55.07723475458962, 53.15831877427997],
        [55.07893338538716, 53.157934744527594]...
      ]
      }
    glid: "78928"
    isAlive: true
    leaf: true
    manualArea: false
    name: "МИУС_Башкиргусь_009"
    verticesHash: "6b0cf9ea95c3f8b75ce529d8c2d98bed"
    zoneType: "field"
  }
 *
 * **/

let suffix = () => Math.floor(Math.random() * 1000);

type ElementIdType = string
type FigureLinkType = object
type LayerNameType = string
type FilterName = string

export enum ColorEnum {
  RED = "#FF0000",
  WHITE = "#FFFFFF",
  DEEP_GREEN = "#32a852",
  AS_GEOZONE_BASE = "#008000",
  LIGHT_GREEN = "#f0f7f2"
}

enum EventsEnum {
  MOUSEDOWN = "mousedown",
  TOUCHSTART = "touchstart",
  MOUSEUP = "mouseup",
  MOUSEUPOUTSIDE = "mouseupoutside",
  TOUCHEND = "touchend",
  TOUCHENDOUTSIDE = "touchendoutside",
  MOUSEMOVE = "mousemove",
  TOUCHMOVE = "touchmove",
  POINTERDOWN = "pointerdown",
  RIGHTDOWN = "rightdown",
  RIGHTUP = "rightup",

}

enum SelectionModeEnum {
  MULTI = "MULTI",
  SINGLE = "SINGLE"
}

export enum PixiOverlayLayerType {
  UNITS = "UNITS",
  FIELDS = "FIELDS",
  // слой для сброса выделения (самый нижний слой)(облатает белым оттенком для ясности)
  RESET = "RESET"
}

enum MouseCursorEnum {
  SELECT = "SELECT",
  POINTER = "POINTER",
  DEFAULT = "DEFAULT"
}

enum GeometryEnum {
  UNIT_SPRITE = "UNIT_SPRITE",
  UNIT_TRACK = "UNIT_TRACK",
  FIELD_POLYGON = "FIELD_POLYGON",
  FIELD_TEXT = "FIELD_TEXT",
  RESET_PLACE = "RESET_PLACE",
}

enum CustomLayersEnum {
  RESET_SELECT = "RESET_SELECT",
}

enum SettingEnum {
  CHANGE_MOUSE_STATUS = "CHANGE_MOUSE_STATUS",
  CREATE_LAYER = "CREATE_LAYER",
  UPDATE_LAYER = "UPDATE_LAYER",
  CHANGE_SETTING = "CHANGE_SETTING",
  CHANGE_SETTING_OVERLAY = "CHANGE_SETTING_OVERLAY",
  SELECT_ELEMENTS = "SELECT_ELEMENTS",
  ON_SELECT_MODE = "ON_SELECT_MODE",
  SET_EVENT = "SET_EVENT",
  CHANGE_CREATED_OBJECT = "CHANGE_CREATED_OBJECT",
  CREATE_OBJECT = "CREATE_OBJECT",
  OBJECT_FOR_CONTEXT_MENU = "OBJECT_FOR_CONTEXT_MENU"
}

enum ColorCodeType {
  DEC = "DEC"
}

enum KeyWordsEnum {
  SHIFT = "Shift",
  KEYDOWN = "keydown",
  KEYUP = "keyup"
}

enum MouseClickEnum {
  DOWN = "DOWN",
  UP = "UP",
  CLICK = "CLICK",
  MOVE = "MOVE",
  NOTOUCH = "NOTOUCH"
}

//===>
type OptionsType = {
  zIndex: number
}
export type CreateUpdateProps = {
  type: PixiOverlayLayerType,
  hashOfBaseList: AsObjectHashMap<GeoZoneHashElement>,
  options: any,
  dynamic: any[],
  filters: any[]
}
type FieldDrawData = {
  geoZone: GeoZoneHashElement,
  options: OptionsType,
  type: PixiOverlayLayerType
}
type UnitDrawData = {
  unit: FigureLinkType,
  options: OptionsType,
  type: PixiOverlayLayerType
}
type DataForUpdateType = {
  hashBaseItem: FigureLinkType,
  options: OptionsType
}

export interface ElementGraphic extends PIXI.Graphics {
  glid: string
  typeLayer: string
  color: number
  baseColor: number
}

type DrawIcon = { type: PixiOverlayLayerType, unit: any, options: OptionsType }
type HashOfBaseType = { [key: ElementIdType]: FigureLinkType[] }
type ItemHashLayersType = { [key: ElementIdType]: HashOfBaseType }
type BaseHashMapItemsType = { hashOfBaseList: AsObjectHashMap<HashElement>, options: OptionsType }
type LayersTreeContainerType = { [key: LayerNameType]: PIXI.Container }
type LayersHashMapsType = { [key: LayerNameType]: ItemHashLayersType }
type BaseHashMapsType = {
  hashOfBaseList: AsObjectHashMap<HashElement>
  options: OptionsType
}
type ChangesListIdType = { [key: LayerNameType]: ElementIdType[] }
type FiltersType = { [key: LayerNameType]: FilterName[] }
type PositionMouseType = { x: number, y: number }
type SizeScaleType = { icon: { w: number, h: number } }
//===>
type MouseType = {
  cursor: {
    type: MouseCursorEnum,
    img: any
  },
  position: PositionMouseType,
  status: MouseClickEnum,
  selectMode: SelectionModeEnum
}
type MapType = {
  link: any
}
export type IOverlay = {
  options: any
  link?: L.Layer,
  container: PIXI.Container,
  firstDraw: boolean,
  prevZoom: number,
  sizeScale: SizeScaleType,
  setting?: OverlaySetting
}

type ProjectFn = (latlng: LatLngExpression) => Point

export type OverlaySetting = {
  zoom?: number,
  mainPixiContainer?: PIXI.Container
  renderer?: any,
  project: ProjectFn,
  scale?: number,
  map?: L.Map,
  boundLeaflet?: any,
  boundPixi?: any
}
//===>
type MetaType = {
  mouse: MouseType,
  map: MapType
  overlay: IOverlay,
}
type DataType = {
  containerLayers: LayersTreeContainerType
  hashOfLayersObjects: LayersHashMapsType
  hashOfBaseObjects: { [k: string] : BaseHashMapsType }
}

type StateType = {
  mode: {
    type: ModeEnum
  }
  events: any
  selected: any[]
  filters: { [key: string]: string[] }
  dynamic: { [key: string]: string[] }
}
type ImgType = {
  map: {
    stand: PIXI.Texture
    move: PIXI.Texture
  }
}
type CoordsFullScreen = PixiCoordFullType | LeafletCoordFullType

type LeafletCoordFullType = { latNE: number, lngNE: number, latSW: number, lngSW: number }
type PixiCoordFullType = { xNE: number, yNE: number, xSW: number, ySW: number }
const log = logger.getLogger("pixi.leaflet")

//================+++++>
class LeafletPixiOverlayService {
  img: ImgType = {
    map: {
      stand: PIXI.Texture.from(mapStandArrowUnit),
      move: PIXI.Texture.from(mapArrowUnit)
    }
  }
  meta: MetaType = {
    map: {
      link: null
    },
    overlay: {
      link: undefined,
      container: new PIXI.Container(),
      firstDraw: true,
      prevZoom: 0,
      sizeScale: {
        icon: {
          w: 0, h: 0
        }
      },
      options: {
        padding: 0.2, // число; по умолчанию 0.1) Насколько расширить область рисования вокруг вида карты (относительно ее размера)
        // forceCanvas: true, // (bool; по умолчанию false) Принудительно использовать 2D-холст для рендеринга.
        // doubleBuffering: false, // (bool; по умолчанию false) Активировать двойную буферизацию, чтобы предотвратить мерцание при обновлении экрана на некоторых устройствах (особенно на устройствах iOS). Это поле игнорируется, если рендеринг выполняется с помощью 2d-canvas.
        // resolution, // (число; по умолчанию 2на устройствах с сетчаткой и 1в других местах) Разрешение средства визуализации.
        // projectionZoom, // (функция(карта): число; по умолчанию используется функция, которая возвращает среднее значение, map.getMinZoom()и map.getMaxZoom()если последнее конечно, иначе возвращается map.getMinZoom() + 8) возвращает уровень масштабирования проекции. Настройка этого параметра может помочь, если вы испытываете визуальные артефакты.
        // pane, // (строка; по умолчанию ) Панель'overlayPane' листовок , в которую вставлен контейнер наложения.
        // destroyInteractionManager: true, // (bool; по умолчанию false) Уничтожить PIXI Interaction Manager . Это полезно, когда вам не нужно использовать взаимодействие PIXI.
        // autoPreventDefault, // (bool; по умолчанию true) Настроить свойство PIXI Interaction Manager autoPreventDefault . Эта опция игнорируется, если destroyInteractionManagerесть true. В большинстве случаев это значение должно быть установлено, чтобы false все события dom могли передаваться из PIXI в листовку, но оно установлено по умолчанию из соображений совместимости.
        // preserveDrawingBuffer, // (bool; по умолчанию false) Включает сохранение буфера рисования, включите его, если вам нужно вызвать toDataUrl в контексте webgl.
        // clearBeforeRender: false, // (bool; по умолчанию false) Устанавливает, будет ли рендерер очищать холст или нет перед новым проходом рендеринга.
        // shouldRedrawOnMove: true // (function(e: moveEvent): Boolean; по умолчанию function () {return false;}) События перемещения запускают перерисовку, когда эта функция возвращает значение true. Например, использование function (e) {return e.flyTo || e.pinch;}вызовет перерисовку во время flyTo анимации и масштабирования.

      }
    },
    mouse: {
      status: MouseClickEnum.NOTOUCH,
      cursor: {
        type: MouseCursorEnum.DEFAULT,
        img: {}
      },
      position: {x: 0, y: 0},
      selectMode: SelectionModeEnum.SINGLE
    }
  }
  state: StateType = {
    mode: {
      type: ModeEnum.BASE
    },
    events: {},
    selected: [],
    filters: {},
    dynamic: {}
  }
  data: DataType = {
    containerLayers: {},
    hashOfLayersObjects: {},
    hashOfBaseObjects: {},
  }

  isInit: boolean = false
  renderers: MapRenderer<HashElement>[] = []
  renderersByName: { [key: string] : MapRenderer<HashElement> } = {}

  constructor(map: any) {
    //@ts-ignore
    window.LeafletPixiOverlay = this
    window.addEventListener("keydown", this.pressKey.bind(this))
    window.addEventListener("keyup", this.pressKey.bind(this))
    window.addEventListener("mousedown", this.handleClick.bind(this))
    this.meta.map.link = map
  }

  public init = ({setting, events}: any, renderers: (overlay: LeafletPixiOverlayService) => MapRenderer<HashElement>[]) => {
    if (!this.isInit) {
      this.installOverlay(() => events.onReady(this, this.meta.overlay));
      this.reducer(SettingEnum.CHANGE_SETTING, setting);
      this.reducer(SettingEnum.SET_EVENT, events, false);
      this.createLayer({type: PixiOverlayLayerType.RESET, hashOfBaseList: {}, dynamic: [], filters: [], options: {zIndex: 5}});
      this.isInit = true
    }
    this.renderers = renderers(this)
    this.renderersByName = groupByProp<MapRenderer<HashElement>>('name')(this.renderers)
  }
  public getRendererByName<T extends MapRenderer<HashElement>>(k: T['name']): T {
    return this.renderersByName[k] as T
  }

  private readonly isVisibleByFilter = (object: any, namesLayer: PixiOverlayLayerType): boolean => {
    let filters = this.state.filters[namesLayer] || []
    if (filters.length) {
      return !filters.includes(object.glid);
    }
    return true
  }
  private readonly getZoomVisibility = (type: GeometryEnum) => {
    let zoom = this.meta.overlay.setting?.zoom || 0;
    switch (type) {
      case GeometryEnum.FIELD_TEXT:
        return zoom > 12
    }
    return false
  }
  private readonly createHashField = (hashMap: any, id: any, nameAttr: string, insertElem: any) => {
    if (hashMap[id]) {
      hashMap[id][nameAttr] = insertElem;
    } else {
      hashMap[id] = {};
      hashMap[id][nameAttr] = insertElem;
    }
  }
  private readonly getCoordsFullScreen = (type: GlobalLayerEnum = GlobalLayerEnum.PIXI): CoordsFullScreen => {
    let {boundPixi: {max, min}, boundLeaflet, project}: any = this.meta.overlay.setting

    let {_northEast, _southWest} = boundLeaflet;

    let {lat: latNE, lng: lngNE} = _northEast
    let {lat: latSW, lng: lngSW} = _southWest

    switch (type) {
      case GlobalLayerEnum.PIXI: {
        let {x: xNE, y: yNE} = project([latNE, lngNE])
        let {x: xSW, y: ySW} = project([latSW, lngSW])
        return {xNE, yNE, xSW, ySW}
      }
      case GlobalLayerEnum.LEAFLET: {
        return {latNE, lngNE, latSW, lngSW}
      }
    }

  }

  public createLayer(value: CreateUpdateProps) {
    let {type, hashOfBaseList, dynamic = [], options, filters = []} = value
    log.debug("Create layer with type " + type, value)

    this.state.filters[type] = filters
    this.state.dynamic[type] = dynamic

    let layerContainer: any = new PIXI.Container();

    layerContainer.typeLayer = type;
    layerContainer.zIndex = options.zIndex
    layerContainer.sortableChildren = true;

    this.data.containerLayers[type] = layerContainer
    this.data.hashOfLayersObjects[type] = {}
    this.data.hashOfBaseObjects[type] = {hashOfBaseList, options}

    if (!(this.meta.overlay.setting?.mainPixiContainer?.children.find((i: any) => i.typeLayer === type))) {
      this.meta.overlay.setting?.mainPixiContainer?.addChild(layerContainer)
    }

    this.draw(type)
    this.refreshPixiContainer()
  }

  public updateLayer(value: CreateUpdateProps) {
    let {type, hashOfBaseList, dynamic = [], options, filters = []} = value
    this.state.filters[type] = filters
    this.state.dynamic[type] = dynamic

    this.data.hashOfBaseObjects[type] = {hashOfBaseList, options}

    this.redraw(type)
    this.refreshPixiContainer()
  }
  public getPixiRootRenderer(): PIXI.Renderer {
    return this.meta.overlay.setting?.renderer
  }
  public refreshPixiContainer(){
    // TODO! Throttle this
    log.info("Refresh PIXI root container")
    this.meta.overlay.setting?.renderer.render(this.meta.overlay.setting?.mainPixiContainer);
  }

  public getSettings() : OverlaySetting | undefined{
    return this.meta.overlay.setting
  }

  //===> manager state
  private readonly reducer = (action: SettingEnum, value: any, isRerender: boolean = true) => {
    log.debug('God reducer', action)
    // const value = Object.assign({}, selfValue)

    if (action === SettingEnum.CREATE_LAYER) {
        log.warn("Deprecated usage")
        // this.createLayerR(value)
    } else if (action === SettingEnum.UPDATE_LAYER) {
      log.warn("Deprecated usage")
      // this.updateLayerR(value)

    } else if (action === SettingEnum.CHANGE_SETTING) {
      this.state.selected = value?.selected?.list || []

      this.redraw();

    } else if (action === SettingEnum.SET_EVENT) {

      this.state.events = value

    } else if (action === SettingEnum.CHANGE_SETTING_OVERLAY) {

      let {zoom, renderer, scale} = value
      let size = scale < 100 ? 20 / scale : 0.2

      this.meta.overlay = {
        ...this.meta.overlay,
        setting: value,
        firstDraw: false,
        prevZoom: zoom,
        sizeScale: {icon: {w: size, h: size}}
      }
      // this.renderers.forEach(renderer => renderer.onPixiOverlayChange(this.getSettings()!))
      // this.redraw()

    } else if (action === SettingEnum.OBJECT_FOR_CONTEXT_MENU) {
      let {glid, typeGeometry, typeLayer} = value.currentTarget
      const baseObject: any = this.data.hashOfBaseObjects[typeLayer].hashOfBaseList[glid]

      this.state.events.addToContextMenu(baseObject)
    } else if (action === SettingEnum.SELECT_ELEMENTS) {
      log.debug('select', value.currentTarget)
      let {glid, typeGeometry, typeLayer} = value.currentTarget
      let tempSelectObject: any = {list: [], type: typeLayer}
      // if (typeLayer === PixiOverlayLayerType.RESET) {
      //   log.debug("click on reset", this.state.selected)
      //   this.state.events.onSelect(tempSelectObject);
      // } else {
        const objects = this.data.hashOfBaseObjects[typeLayer]
        const baseObject: any = objects?.hashOfBaseList ? objects.hashOfBaseList[glid] : null
        const baseObjectGlid = baseObject?.glid

        switch (this.meta.mouse.selectMode) {
          case SelectionModeEnum.SINGLE: {
            tempSelectObject.list = baseObjectGlid ? [baseObjectGlid] : []

            this.state.events.onSelect(tempSelectObject);
            break;
          }
          case SelectionModeEnum.MULTI: {
            let isFindElement = this.state.selected.find((i: any) => i.glid == glid)
            if (isFindElement) {
              tempSelectObject.list = this.state.selected.filter((i: any) => i.glid !== glid)
            } else if(baseObjectGlid) {
              tempSelectObject.list = [...this.state.selected, baseObjectGlid]
            } else {
              tempSelectObject.list = []
            }
            this.state.events.onSelect(tempSelectObject);
            break;
          }
        }
      // }
    } else if (action === SettingEnum.ON_SELECT_MODE) {
      this.meta.mouse.selectMode = value
        ? SelectionModeEnum.MULTI
        : SelectionModeEnum.SINGLE
    } else if (action === SettingEnum.CHANGE_MOUSE_STATUS) {
      this.meta.mouse.status = value.status
    }
    if (isRerender) this.meta.overlay.setting?.renderer.render(this.meta.overlay.setting?.mainPixiContainer);
  }

  //===> call reduce
  private readonly pressKey = (e: any) => {
    let {key, type} = e
    switch (key) {
      case KeyWordsEnum.SHIFT: {
        this.reducer(SettingEnum.ON_SELECT_MODE, type === KeyWordsEnum.KEYDOWN)
        break;
      }
    }
  }
  private readonly handleClick = (e: any) => {
    this.reducer(SettingEnum.CHANGE_MOUSE_STATUS, {status: MouseClickEnum.CLICK}, false)
  }
  public readonly setup = (setting: any) => {
    this.reducer(SettingEnum.CHANGE_SETTING, setting)
  }
  // public readonly createLayer = (props: CreateUpdateProps) => {
  //   this.reducer(SettingEnum.CREATE_LAYER, props)
  // }
  // public readonly updateLayer = (props: CreateUpdateProps) => {
  //   this.reducer(SettingEnum.UPDATE_LAYER, props)
  // }
  private readonly setSelect = (type: SettingEnum) => (e: any) => {
    this.reducer(type, e, true)
  }

  private readonly setObjectForContextMenu = (type: SettingEnum) => (e: any) => {
    this.reducer(type, e, false)
  }

  private readonly installOverlay = (onReady: () => void) => {
    const self = this;
    const {meta} = self
    let {map, overlay} = meta
    let firstDraw = true
    meta.overlay.link?.remove()
    // @ts-ignore
    meta.overlay.link = L.pixiOverlay((utils: any, events: any) => {
      const settingOverlay = {
        zoom: utils.getMap().getZoom(),
        mainPixiContainer: utils.getContainer(),
        renderer: utils.getRenderer(),
        project: utils.latLngToLayerPoint,
        scale: utils.getScale(),
        map: utils.getMap(),
        boundLeaflet: utils.getMap().getBounds(),
        boundPixi: utils.getMap().getPixelBounds()
      }
      self.reducer(SettingEnum.CHANGE_SETTING_OVERLAY, settingOverlay)

      if (firstDraw) {
        onReady()
        log.debug("Install PIXI overlay...", settingOverlay)
        firstDraw = false
      }
    }, overlay.container, overlay.options)
    overlay.container.sortableChildren = true;

    overlay.link?.addTo(map.link)

    map.link.on('move', () => {
      self.reducer(SettingEnum.CHANGE_MOUSE_STATUS, {status: MouseClickEnum.MOVE}, false)
    })
  }

  private readonly draw = (type: PixiOverlayLayerType) => {

    let containerLayers = this.data.containerLayers[type] as PIXI.Container;
    let hashLayerObject = this.data.hashOfLayersObjects[type];
    let {hashOfBaseList, options}: BaseHashMapItemsType = this.data.hashOfBaseObjects[type];

    switch (type) {
      case PixiOverlayLayerType.FIELDS:
        for (let hashOfBaseId in hashOfBaseList) {
          let field = hashOfBaseList[hashOfBaseId];

          let fieldDrawData = {geoZone: field, options, type} as FieldDrawData;
          // this.drawField(fieldDrawData, hashLayerObject, containerLayers);
        }
        break;
      case PixiOverlayLayerType.UNITS:
        for (let hashOfBaseId in hashOfBaseList) {
          let unit = hashOfBaseList[hashOfBaseId];
          let unitDrawData = {type, unit, options} as UnitDrawData;

          this.drawUnits(unitDrawData, hashLayerObject, containerLayers)
        }
        break;
      case PixiOverlayLayerType.RESET: {
        this.drawResetPlace(containerLayers)
        break;
      }
    }

  }

  renderTrack(elementLayer: ElementGraphic, baseObject: UnitHashElement) {
    let {trackPoints} = baseObject.dynamic;
    let {project} = this.meta.overlay.setting as OverlaySetting
    if (trackPoints) {
      elementLayer.clear()
      elementLayer.lineStyle(0.1, 0x006400, 1);
      trackPoints.forEach((point: TrackPoint, index: number, array: any) => {
        let {x, y} = project([point.lat, point.lon])
        if (index === 0) elementLayer.moveTo(x, y)
        else elementLayer.lineTo(x, y);
      })
    }
    elementLayer.visible = this.isVisibleByFilter(baseObject, PixiOverlayLayerType.UNITS)
  }

  renderPolygon(elementLayer: ElementGraphic , baseObject: GeoZoneHashElement) {
    log.debug('redraw polygon')
    let {typeLayer, glid} = elementLayer
    let currentDynamic = this.state.dynamic[typeLayer];
    if (currentDynamic.filter((i: any) => i == glid).length) {

      // let baseObject: GeoZoneHashElement = this.data.hashOfBaseObjects[typeLayer].hashOfBaseList[glid] as GeoZoneHashElement
      if (baseObject?.dynamic?.cropsInfo?.cropData?.length) {
        let color = baseObject.dynamic.cropsInfo.cropData[0].color
        elementLayer.tint = hex2number(color);
        elementLayer.baseColor = hex2number(color);
      }
    }
    if (this.state.selected.filter((i: any) => i === glid).length) {
      elementLayer.alpha = 1
    } else {
      elementLayer.alpha = 0.5
    }
    elementLayer.visible = this.isVisibleByFilter(baseObject, PixiOverlayLayerType.FIELDS)
  }

  renderUnitSprite(elementLayer: any, baseObject: UnitHashElement) {
    let { glid } = elementLayer

    let { move, stand } = this.img.map
    let { project } = this.meta.overlay.setting as OverlaySetting
    let { sizeScale } = this.meta.overlay
    let { unitState, trackPoints, azimuth, position: p } = baseObject.dynamic

    elementLayer.texture = trackPoints && trackPoints?.length > 1 ? move : stand
    elementLayer.tint = getColorByStatusUnits(unitState, ColorCodeType.DEC)
    elementLayer.angle = azimuth
    // if (p.length) {
    //   let pProject = project([p[1], p[0]])
    //   elementLayer.x = pProject.x
    //   elementLayer.y = pProject.y
    // }

    elementLayer.height = sizeScale.icon.h
    elementLayer.width = sizeScale.icon.w

    if (this.state?.selected?.filter((i: any) => i === glid).length) {
      elementLayer.alpha = 1
    } else {
      elementLayer.alpha = 0.5
    }
    elementLayer.visible = this.isVisibleByFilter(baseObject, PixiOverlayLayerType.UNITS)
  }

  // TODO! Decompose
  private readonly redraw = (type?: PixiOverlayLayerType) => {
    let {scale = 0} = this.meta.overlay.setting as OverlaySetting
    this.meta.overlay.container.children.forEach((layer: any) => {

      if (layer.typeLayer === PixiOverlayLayerType.RESET) {
        this.drawResetPlace(layer)
      } else {
        layer.children.forEach((elementLayer: any) => {
          let { typeLayer, typeGeometry, glid } = elementLayer
          let currentDynamic = this.state.dynamic[typeLayer];
          let baseObject: any = currentDynamic?.length ? this.data.hashOfBaseObjects[typeLayer]?.hashOfBaseList[glid] : {}
          if (!baseObject) {
            return console.error('Entity object is not found by glid ' + glid, this.data.hashOfBaseObjects)
          }
          switch (typeGeometry as GeometryEnum) {
            case GeometryEnum.FIELD_POLYGON: {
              this.renderPolygon(elementLayer, baseObject)
              this.renderers.filter(i => i.isMatch(baseObject)).forEach(renderer => {
                renderer.render(baseObject, elementLayer)
              })
              break;
            }
            case GeometryEnum.FIELD_TEXT: {
              // elementLayer.scale.x = 1 / scale;
              // elementLayer.scale.y = 1 / scale;
              // elementLayer.visible = this.getZoomVisibility(GeometryEnum.FIELD_TEXT)
              break;
            }
            case GeometryEnum.UNIT_SPRITE: {
              if (baseObject.dynamic) {
                this.renderUnitSprite(elementLayer, baseObject);
              }
              break;
            }
            case GeometryEnum.UNIT_TRACK: {
              if (baseObject.dynamic) {
                this.renderTrack(elementLayer, baseObject);
              }
              break
            }
          }


          if (
              //  TODO! Drop it in favor of GeoZoneRenderer
            (typeGeometry === GeometryEnum.FIELD_POLYGON && !type) ||
            (typeGeometry === GeometryEnum.FIELD_POLYGON && type === PixiOverlayLayerType.FIELDS)
          ) {
            this.renderPolygon(elementLayer, baseObject)
          } else if (
            //  TODO! Drop it in favor of GeoZoneRenderer
            (typeGeometry === GeometryEnum.FIELD_TEXT && !type) ||
            (typeGeometry === GeometryEnum.FIELD_TEXT && type === PixiOverlayLayerType.FIELDS)
          ) {
            // elementLayer.scale.x = 1 / scale;
            // elementLayer.scale.y = 1 / scale;
            // elementLayer.visible = this.getZoomVisibility(GeometryEnum.FIELD_TEXT)
          } else if (
            (typeGeometry === GeometryEnum.UNIT_SPRITE && !type) ||
            (typeGeometry === GeometryEnum.UNIT_SPRITE && type === PixiOverlayLayerType.UNITS)
          ) {
            if (baseObject.dynamic) {
              this.renderUnitSprite(elementLayer, baseObject)
            }
          } else if (
            (typeGeometry === GeometryEnum.UNIT_TRACK && !type) ||
            (typeGeometry === GeometryEnum.UNIT_TRACK && type === PixiOverlayLayerType.UNITS)
          ) {
            if (baseObject.dynamic) {
              this.renderTrack(elementLayer, baseObject)
            }
          }
        }, this)
      }
    })
  }

  //===================================================================================>
  private readonly drawField = (fieldDrawData: FieldDrawData, hashLayerObject: ItemHashLayersType, containerLayers: PIXI.Container) => {
    let polygon: PIXI.Graphics = new PIXI.Graphics();
    let text: PIXI.Text = new PIXI.Text("");

    polygon.visible = this.isVisibleByFilter(fieldDrawData, PixiOverlayLayerType.FIELDS)
    text.visible = this.getZoomVisibility(GeometryEnum.FIELD_TEXT);

    this.drawPolygon(fieldDrawData, polygon, hashLayerObject, containerLayers)
    this.drawTitle(fieldDrawData, polygon, text, hashLayerObject, containerLayers)
  }

  private readonly drawUnits = (unitDrawData: UnitDrawData, hashLayerObject: ItemHashLayersType, containerLayers: PIXI.Container) => {
    let arrow: PIXI.Sprite = new PIXI.Sprite();
    let line: PIXI.Graphics = new PIXI.Graphics();

    arrow.visible = this.isVisibleByFilter(unitDrawData, PixiOverlayLayerType.UNITS)
    line.visible = this.isVisibleByFilter(unitDrawData, PixiOverlayLayerType.UNITS)

    this.drawUnitIcon(unitDrawData, arrow, hashLayerObject, containerLayers)
    this.drawTrack(unitDrawData, line, hashLayerObject, containerLayers)
  }

  //===================================================================================>
  private readonly drawUnitIcon = (unitDrawData: UnitDrawData, arrow: PIXI.Sprite, hashLayerObject: ItemHashLayersType, containerLayers: PIXI.Container) => {
    let {unit, options, type}: any = unitDrawData

    //@ts-ignore
    arrow.glid = unit.glid
    //@ts-ignore
    arrow.typeGeometry = GeometryEnum.UNIT_SPRITE
    //@ts-ignore
    arrow.typeLayer = type

    arrow.interactive = true
    arrow.buttonMode = true
    arrow.zIndex = options.zIndex - 5
    arrow.visible = true
    arrow.anchor.set(0.5);

    this.subscribe({
      event: EventsEnum.MOUSEUP,
      object: arrow,
      func: this.setSelect(SettingEnum.SELECT_ELEMENTS),
      self: this
    })

    this.subscribe({
      event: EventsEnum.RIGHTDOWN,
      object: arrow,
      func: this.setObjectForContextMenu(SettingEnum.OBJECT_FOR_CONTEXT_MENU),
      self: this
    })

    this.createHashField(hashLayerObject, unit.glid, GeometryEnum.UNIT_SPRITE, arrow)
    containerLayers.addChild(arrow)
  }

  private readonly drawTrack = (unitDrawData: UnitDrawData, line: PIXI.Graphics, hashLayerObject: ItemHashLayersType, containerLayers: PIXI.Container) => {
    let {unit, options, type}: any = unitDrawData

    //@ts-ignore
    line.glid = unit.glid
    //@ts-ignore
    line.typeGeometry = GeometryEnum.UNIT_TRACK
    //@ts-ignore
    line.typeLayer = type
    //@ts-ignore
    line.join = "ROUND"
    //@ts-ignore
    line.cap = "ROUND"
    //@ts-ignore
    line.native = true

    line.clear()
    line.zIndex = options.zIndex - 10
    line.lineStyle(0.2, 0x006400, 1);

    this.createHashField(hashLayerObject, unit.glid, GeometryEnum.UNIT_TRACK, line)
    containerLayers.addChild(line)
  }

  //===================================================================>
  private readonly drawTitle = (fieldDrawData: FieldDrawData, polygon: PIXI.Graphics, text: PIXI.Text, hashLayerObject: ItemHashLayersType, containerLayers: PIXI.Container) => {
    let {geoZone, options, type}: any = fieldDrawData

    //@ts-ignore
    text.glid = geoZone.glid
    //@ts-ignore
    text.typeGeometry = GeometryEnum.FIELD_TEXT
    //@ts-ignore
    text.typeLayer = type

    const {x: boundX, y: boundY, width: boundWidth = 0, height: boundHeight = 0} = polygon.getLocalBounds()
    text.style = new PIXI.TextStyle({
      // fontFamily: 'Arial',
      fontSize: 12,
      // fontStyle: 'italic',
      // fill : '#F7EDCA',
      // stroke : '#4a1850',
      // strokeThickness : 5,
      // dropShadow : true,
      // dropShadowColor : '#000000',
      // dropShadowAngle : Math.PI / 6,
      // dropShadowDistance : 6,
      wordWrap: true,
      wordWrapWidth: boundWidth
    })
    text.text = geoZone.name
    text.anchor.x = 0.5;
    text.zIndex = options.zIndex

    text.x = boundX + (boundWidth / 2)
    text.y = boundY + (boundHeight / 2)

    this.createHashField(hashLayerObject, geoZone.glid, GeometryEnum.FIELD_TEXT, text)
    containerLayers.addChild(text);
  }

  private readonly drawPolygon = (fieldDrawData: FieldDrawData, polygon: PIXI.Graphics, hashLayerObject: ItemHashLayersType, containerLayers: PIXI.Container) => {
    log.debug('draw poly')
    let {geoZone, options, type}: FieldDrawData = fieldDrawData

    let {project}: any = this.meta.overlay.setting

    let color = hex2number(geoZone.color || ColorEnum.AS_GEOZONE_BASE);
    let opacity = hex2number(ColorEnum.WHITE);

    //@ts-ignore
    polygon.baseColor = color
    //@ts-ignore
    polygon.glid = geoZone.glid
    //@ts-ignore
    polygon.typeGeometry = GeometryEnum.FIELD_POLYGON
    //@ts-ignore
    polygon.typeLayer = type

    polygon.zIndex = geoZone.zoneType === "cadastre" ? options.zIndex - 1 : options.zIndex
    polygon.interactive = true
    polygon.buttonMode = true
    polygon.lineStyle(.01, color, .7);
    polygon.beginFill(opacity, 1);
    polygon.tint = color

    if (geoZone?.geometry?.coordinates) {
      let {geometry} = geoZone
      geometry.coordinates.map((item: any) => item.forEach(([xL, yL]: any, index: number) => {
        let {x, y} = project([yL, xL])
        if (index === 0) polygon.moveTo(x, y);
        else polygon.lineTo(x, y);
      }))
    }

    polygon.endFill();

    this.subscribe({
      event: EventsEnum.MOUSEUP,
      object: polygon,
      func: this.setSelect(SettingEnum.SELECT_ELEMENTS),
      self: this
    })

    this.subscribe({
      event: EventsEnum.RIGHTUP,
      object: polygon,
      func: this.setObjectForContextMenu(SettingEnum.OBJECT_FOR_CONTEXT_MENU),
      self: this
    })

    this.createHashField(hashLayerObject, geoZone.glid, GeometryEnum.FIELD_POLYGON, polygon)
    containerLayers.addChild(polygon)
  }

  private readonly drawResetPlace = (container: any) => {
    container.removeChildren()
    let {xNE, yNE, xSW, ySW} = this.getCoordsFullScreen() as PixiCoordFullType

    let color: any = hex2number(ColorEnum.WHITE)

    let resetSelect: any = new PIXI.Graphics();
    resetSelect.clear();
    resetSelect.interactive = true
    resetSelect.buttonMode = true
    // resetSelect.typeLayer = PixiOverlayLayerType.RESET
    // resetSelect.typeGeometry = GeometryEnum.RESET_PLACE
    resetSelect.beginFill(color, 0.0001);
    resetSelect.drawRect(xSW, yNE, xNE - xSW, ySW - yNE);
    resetSelect.endFill();
    resetSelect.on('click', () => {
      this.renderers.forEach(r => r.onOutsideClick())
    })
    this.subscribe({
      event: EventsEnum.MOUSEUP,
      object: resetSelect,
      func: this.setSelect(SettingEnum.SELECT_ELEMENTS),
      self: this
    });

    container.addChild(resetSelect)
  }

  //======> subscribe events
  private readonly eventHandler = (props: any) => (e: any) => {
    e.stopPropagation()

    if (e.target) {
      let {func, checkMove, delay} = props
      switch (e.type) {
        case EventsEnum.MOUSEDOWN: {
          this.reducer(SettingEnum.CHANGE_MOUSE_STATUS, MouseClickEnum.CLICK, false)
          break;
        }
        case EventsEnum.MOUSEMOVE: {
          this.reducer(SettingEnum.CHANGE_MOUSE_STATUS, MouseClickEnum.MOVE, false)
          break;
        }
      }
      if (checkMove) {
        if (this.meta.mouse.status === MouseClickEnum.CLICK) {
          delay ? setTimeout(() => func(e), 0) : func(e)
        }
      } else {
        func(e)
      }
    }
  };

  private readonly subscribe = (props: { event: EventsEnum, object: any, func: any, checkMove?: boolean, delay?: boolean, self?: any }) => {
    let {object, func, checkMove = true, event, delay = false, self = this} = props
    object.interactive = true;
    object.buttonMode = true;
    object.on(event, this.eventHandler({func, checkMove, delay}).bind(self))
  }
  //===================================================+>

}

export default LeafletPixiOverlayService;